// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";  // ← add this
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA7weLi-yqC95aLefgeptGF4w6joWsNzds",
  authDomain: "elevate-5a47e.firebaseapp.com",
  projectId: "elevate-5a47e",
  storageBucket: "elevate-5a47e.firebasestorage.app",
  messagingSenderId: "596923159537",
  appId: "1:596923159537:web:14f104c90e9fe9cb5d2a50",
  measurementId: "G-0TMZ6NZ5B3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);  // ← and this
export const functions = getFunctions(app);  // us-central1 (matches the deployed callables)